import {
  PRODUCTCATEGORY_LIST_REQUEST,
  PRODUCTCATEGORY_LIST_SUCCESS,
  PRODUCTCATEGORY_LIST_FAIL,
  PRODUCTCATEGORY_DETAILS_REQUEST,
  PRODUCTCATEGORY_DETAILS_SUCCESS,
  PRODUCTCATEGORY_DETAILS_FAIL,
  PRODUCTCATEGORY_CREATE_REQUEST,
  PRODUCTCATEGORY_CREATE_SUCCESS,
  PRODUCTCATEGORY_CREATE_FAIL,
  PRODUCTCATEGORY_CREATE_RESET,
  PRODUCTCATEGORY_UPDATE_REQUEST,
  PRODUCTCATEGORY_UPDATE_SUCCESS,
  PRODUCTCATEGORY_UPDATE_FAIL,
  PRODUCTCATEGORY_UPDATE_RESET,
  PRODUCTCATEGORY_DELETE_REQUEST,
  PRODUCTCATEGORY_DELETE_SUCCESS,
  PRODUCTCATEGORY_DELETE_FAIL,
} from "../constants/productCategoryConstants";

// Reducer to list product categories
export const productCategoryListReducer = (
  state = { productCategories: [], totalCount: 0 },
  action
) => {
  switch (action.type) {
    case PRODUCTCATEGORY_LIST_REQUEST:
      return { loading: true, productCategories: [] };
    case PRODUCTCATEGORY_LIST_SUCCESS:
      return {
        loading: false,
        productCategories: action.payload.productCategories,
        pages: action.payload.pages,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        totalCount: action.payload.totalCount,
      };
    case PRODUCTCATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer to get product category details
export const productCategoryDetailsReducer = (
  state = { productCategory: {} },
  action
) => {
  switch (action.type) {
    case PRODUCTCATEGORY_DETAILS_REQUEST:
      return { loading: true, ...state };
    case PRODUCTCATEGORY_DETAILS_SUCCESS:
      return { loading: false, productCategory: action.payload };
    case PRODUCTCATEGORY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer to create a new product category
export const productCategoryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCTCATEGORY_CREATE_REQUEST:
      return { loading: true };
    case PRODUCTCATEGORY_CREATE_SUCCESS:
      return { loading: false, success: true, productCategory: action.payload };
    case PRODUCTCATEGORY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCTCATEGORY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer to update a product category
export const productCategoryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCTCATEGORY_UPDATE_REQUEST:
      return { loading: true };
    case PRODUCTCATEGORY_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case PRODUCTCATEGORY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCTCATEGORY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer to delete a product category
export const productCategoryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCTCATEGORY_DELETE_REQUEST:
      return { loading: true };
    case PRODUCTCATEGORY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case PRODUCTCATEGORY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
